import React from "react";
import { Link } from "react-router-dom";

const BreadCrumb = ({ evt }) => {
  const base = process.env.PUBLIC_URL || "";
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="hn-breadcrumb">
      <h1>{evt?.attributes?.title}</h1>
      <nav className="hn-breadcrumb-nav">
        <Link to={`${base}/`} onClick={scrollTop}>Home</Link>
        <i className="bi bi-chevron-right" />
        <Link to={`${base}/events`} onClick={scrollTop}>Events</Link>
        <i className="bi bi-chevron-right" />
        <span>{evt?.attributes?.title}</span>
      </nav>
    </div>
  );
};

export default BreadCrumb;
